import './CarouselCont.css'
import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ActionAreaCard from './Card'
import api_data from '../data/TableData'
import _ from "lodash";

let products = api_data['all_products']

export default class SimpleSlider extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
    };
    const list = products.map((product) => {
      return (
            <ActionAreaCard
          image={product.image}
          titleImage={product.titleImage}
          expirate={product.expirate}
          type={product.tipo} />
      );
    });
    return (
      <div className="containerCarouselGeral">
        <h2>Meus Hardwares</h2>
        <Slider {...settings}>
          {
          _.times(list.length, (i) => (
            <h3 key={i}>{list[i]}</h3>
          ))
        }
        </Slider>
      </div>
    );
  }
}

